import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LoggingInterceptor implements HttpInterceptor {

  private _requestId: number = 0
  get requestId(): number {
    this._requestId += 1
    return this._requestId - 1
  }

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentRequestId = this.requestId
    // console.debug(`[HTTP] #${currentRequestId} Request @ ${new Date(Date.now()).toLocaleString()}`)
    // console.debug(request)
    return next.handle(request).pipe(
      tap(
        response => {
          // console.debug(`[HTTP] #${currentRequestId} Response @ ${new Date(Date.now()).toLocaleString()}`)
          // console.debug(response)
        },
        (error: HttpErrorResponse) => {
          // console.debug(`[HTTP] #${currentRequestId} Error @ ${new Date(Date.now()).toLocaleString()}`)
          // console.debug(error)
        }
      )
    )  }
}
